import React from 'react'
import getImage from './image.const'

const Image = (img) => {
  return <React.Fragment>{getImage(img)}</React.Fragment>
}
export default Image
